import { Injectable } from '@angular/core';
import { UnsettledPaymentsPrintingQuery, UnsettledPaymentsPrintingQueryHandlerBase } from '@skylab-shared/business';

import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(UnsettledPaymentsPrintingQuery)
@Wrapper(UnsettledPaymentsPrintingQueryHandlerBase)
export class UnsettledPaymentsPrintingQueryHandler {
    public constructor(
        http: Http
    ) { }
}
